import { createContext, useContext, useState, useEffect } from "react";

// Argentina is UTC-3, no DST
const DARK_HOUR = 19;   // 19:00 → dark
const LIGHT_HOUR = 7;   // 07:00 → light

function getArgentinaHour() {
  const argTime = new Date(Date.now() - 3 * 3600 * 1000);
  return argTime.getUTCHours();
}

function getScheduledMode() {
  const h = getArgentinaHour();
  return h >= DARK_HOUR || h < LIGHT_HOUR ? "dark" : "light";
}

function msUntilArgentinaHour(targetHour) {
  const argTime = new Date(Date.now() - 3 * 3600 * 1000);
  const argHour = argTime.getUTCHours();
  const argMin  = argTime.getUTCMinutes();
  const argSec  = argTime.getUTCSeconds();
  const argMs   = argTime.getUTCMilliseconds();

  let hoursUntil = targetHour - argHour;
  if (hoursUntil <= 0) hoursUntil += 24;

  return hoursUntil * 3600000 - argMin * 60000 - argSec * 1000 - argMs;
}

const ThemeContext = createContext();

export function ThemeContextProvider({ children }) {
  const [mode, setMode] = useState(() => getScheduledMode());

  useEffect(() => {
    let timeout;

    function scheduleNextSwitch() {
      const current = getScheduledMode();
      // Next boundary: if currently dark → wait for LIGHT_HOUR, else → wait for DARK_HOUR
      const nextHour = current === "dark" ? LIGHT_HOUR : DARK_HOUR;
      const delay = msUntilArgentinaHour(nextHour);

      timeout = setTimeout(() => {
        const next = getScheduledMode();
        setMode(next);
        localStorage.setItem("themeMode", next);
        scheduleNextSwitch();
      }, delay);
    }

    scheduleNextSwitch();
    return () => clearTimeout(timeout);
  }, []);

  const toggleTheme = () => {
    setMode((prev) => {
      const next = prev === "light" ? "dark" : "light";
      localStorage.setItem("themeMode", next);
      return next;
    });
  };

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useThemeMode() {
  return useContext(ThemeContext);
}
